import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
} from "../../Actions";
import { api } from "../../Config/ApiInterface";
import {
  getAllDepartmentListSuccess,
  getAllDepartmentListFailure,
  addDepartmentSuccess,
  addDepartmentFailure,
  updateDepartmentFailure,
  updateDepartmentSuccess,
  deleteDepartmentFailure,
  deleteDepartmentSuccess,

  getAllDepartmentInventoryListSuccess,
  getAllDepartmentInventoryListFailure,
  addDepartmentInventoryFailure,
  addDepartmentInventorySuccess,
  deleteDepartmentInventoryFailure,
  deleteDepartmentInventorySuccess,
  updateDepartmentInventoryFailure,
  updateDepartmentInventorySuccess,

  getAllDepartmentCategoryListFailure,
  getAllDepartmentCategoryListSuccess,
  addDepartmentCategoryFailure,
  addDepartmentCategorySuccess,
  updateDepartmentCategoryFailure,
  updateDepartmentCategorySuccess,
  deleteDepartmentCategoryFailure,
  deleteDepartmentCategorySuccess,
} from "../../Actions/Departments/DepartmentsAction";

// GET category
function*getDepartmentsSaga(action) {
  try {
    const { page=1, limit=100,name='' } = action.payload || {};
    const params = new URLSearchParams({ page, limit,name });
    const hotel_id=localStorage.getItem('hotel_id')

    const response = yield call(api.post, `/departments/all?hotel_id=${hotel_id}&${params}`);
    if (response) {
      yield put(getAllDepartmentListSuccess(response.data));
    } else {
      yield put(getAllDepartmentListFailure(response.error || "Failed to fetch Departments."));
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getAllDepartmentListFailure(error));
    // toast.error("Failed to fetch Departments.");
  }
}

//add category
function* addDepartmentSaga(action) {
  try {
    const response = yield call(
      api.post,
      `/departments/create`,
      action.payload?.body
    );
    if (response) {
      yield put(addDepartmentSuccess(response.data));
      toast.success(response.message);
    } else {
      yield put(
        addDepartmentFailure(response.error || "Failed to add category")
      );
    }
  } catch (error) {
    yield put(addDepartmentFailure(error));
    toast.error("Failed to add category");
  }
}

// Edit category
function* updateDepartmentSaga(action) {
  try {
    const payloadData = action.payload;
    const response = yield call(
      api.put,
      `/departments/${payloadData?.id}`,
      action.payload?.body
    );
    if (response) {
      yield put(updateDepartmentSuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        updateDepartmentFailure(
          response.error || "Failed to update category"
        )
      );
    }
  } catch (error) {
    yield put(updateDepartmentFailure(error));
    toast.error("Failed to update category");
  }
}

//delete room type
function* deleteDepartmentSaga(action) {
  try {
    const payloadData = action.payload;
    const response = yield call(api.delete, `/departments/${payloadData?.id}`);
    if (response) {
      yield put(deleteDepartmentSuccess(response.data));
    } else {
      yield put(
        deleteDepartmentFailure(
          response.error || "Failed to delete room types."
        )
      );
    }
    toast.success(response.message);
  } catch (error) {
    yield put(deleteDepartmentFailure(error));
    toast.error("Failed to delete room types.");
  }
}

// CATEGORY sagas

function* getDepartmentsCategorySaga(action) {
  try {
    const { page=1, limit='100' , name,isAll} = action.payload?.body || {};
    const params = new URLSearchParams({ page, limit ,name});
    const response = yield call(
      api.post,
      isAll ? 'department-categories/all': `/department-categories/by-department/${action.payload.id}?${params}`
    );
    if (response) {
      yield put(getAllDepartmentCategoryListSuccess(response.data));
    } else {
      yield put(
        getAllDepartmentCategoryListFailure(
          response.error || "Failed to fetch Sub Departments."
        )
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getAllDepartmentCategoryListFailure(error));
    // toast.error("Failed to fetch Sub Departments.");
  }
}

function* addDepartmentCategorySaga(action) {
  try {
    const response = yield call(
      api.post,
      `/department-categories/create`,
      action.payload?.body
    );
    if (response) {
      yield put(addDepartmentCategorySuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        addDepartmentCategoryFailure(
          response.error || "Failed to add Dish item"
        )
      );
    }
  } catch (error) {
    yield put(addDepartmentCategoryFailure(error));
    toast.error("Failed to add sub category");
  }
}

function* updateDepartmentCategorySaga(action) {
  try {
    const payloadData = action.payload;
    const response = yield call(
      api.put,
      `/department-categories/${payloadData?.id}`,
      action.payload?.body
    );
    if (response) {
      yield put(updateDepartmentCategorySuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        updateDepartmentCategoryFailure(
          response.error || "Failed to update sub category"
        )
      );
    }
  } catch (error) {
    yield put(updateDepartmentCategoryFailure(error));
    toast.error("Failed to update sub category");
  }
}

function* deleteDepartmentCategorySaga(action) {
  try {
    const payloadData = action.payload;
    const response = yield call(
      api.delete,
      `/department-categories/${payloadData?.id}`
    );
    if (response) {
      yield put(deleteDepartmentCategorySuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        deleteDepartmentCategoryFailure(
          response.error || "Failed to delete sub category"
        )
      );
    }
    toast.success(response.message);
  } catch (error) {
    yield put(deleteDepartmentCategoryFailure(error));
    toast.error("Failed to delete sub category");
  }
}

// INVENTORY
function* getDepartmentInventorySaga(action) {
  try {
    const { page, limit ,name,isAll} = action.payload?.body || {};
    const hotel_id = localStorage.getItem("hotel_id");
    const params = new URLSearchParams({ page, limit, name,hotel_id });
    const response = yield call(
      api.post,
      isAll ? 'department-inventories/all':`/department-inventories/by-category/${action.payload.categoryId}?${params}`
    );
    if (response) {
      yield put(getAllDepartmentInventoryListSuccess(response.data));
    } else {
      yield put(
        getAllDepartmentInventoryListFailure(
          response.error || "Failed to fetch Inventories."
        )
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getAllDepartmentInventoryListFailure(error));
    toast.error("Failed to fetch Inventories.");
  }
}

function* addDepartmentInventorySaga(action) {
  try {
    const response = yield call(
      api.post,
      `/department-inventories/create`,
      action.payload?.body
    );
    if (response) {
      yield put(addDepartmentInventorySuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        addDepartmentInventoryFailure(
          response.error || "Failed to add inventory"
        )
      );
    }
  } catch (error) {
    yield put(addDepartmentInventoryFailure(error));
    toast.error("Failed to add inventory");
  }
}

// Edit varient
function* updateDepartmentInventorySaga(action) {
  try {
    const payloadData = action.payload;
    const response = yield call(
      api.put,
      `/department-inventories/${payloadData?.id}`,
      action.payload?.body
    );
    if (response) {
      yield put(updateDepartmentInventorySuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        updateDepartmentInventoryFailure(
          response.error || "Failed to update inventory"
        )
      );
    }
  } catch (error) {
    yield put(updateDepartmentInventoryFailure(error));
    toast.error("Failed to update inventory");
  }
}

function* deleteDepartmentInventorySaga(action) {
  try {
    const payloadData = action.payload;
    const response = yield call(
      api.delete,
      `/department-inventories/${payloadData?.id}`
    );
    if (response) {
      yield put(deleteDepartmentInventorySuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        deleteDepartmentInventoryFailure(
          response.error || "Failed to delete inventory"
        )
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(deleteDepartmentInventoryFailure(error));
    toast.error("Failed to delete inventory");
  }
}

export {
    getDepartmentsSaga,
    addDepartmentSaga,
    updateDepartmentSaga,
    deleteDepartmentSaga,

    getDepartmentsCategorySaga,
    addDepartmentCategorySaga,
    updateDepartmentCategorySaga,
    deleteDepartmentCategorySaga,

    getDepartmentInventorySaga,
    updateDepartmentInventorySaga,
    addDepartmentInventorySaga,
    deleteDepartmentInventorySaga
};
